import axios from "axios";
import { actionStart, actionSuccess, actionFailed } from "../redux-store/ActionSlice"


export const getUserDetails = async (dispatch) => {
    dispatch(actionStart())
    try {
        const resp = axios.get(process.env.REACT_APP_BASE_URL + '/user/details', {
            headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        })
        dispatch(actionSuccess())
        return resp
    } catch (err) {
        dispatch(actionFailed())
        return err
    }
}

export const updateUser = async (user, dispatch) => {
    dispatch(actionStart())
    try {
        const resp = axios.put(process.env.REACT_APP_BASE_URL + '/user/update', user, {
            headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        })
        dispatch(actionSuccess())
        return resp
    } catch (err) {
        dispatch(actionFailed())
        return err
    }
}